import * as React from "react";
import { forwardRef } from "react";
const SvgToolText = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M5 6.5V4H12M19 6.5V4H12M12 4V20" stroke="#CCCCCC" strokeWidth={2} strokeLinecap="round" /><path d="M9 20H15" stroke="#CCCCCC" strokeWidth={2} strokeLinecap="round" /></svg>;
const ForwardRef = forwardRef(SvgToolText);
export { ForwardRef as ReactComponent };